//@flow
import React, { useState } from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import { find } from 'lodash';
import { DiningMenuCard } from 'components/atoms/diningMenuCard';
import { TextCarouselMobile } from 'components/molecules/textCarouselMobile';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  restaurantCategories: Array<RestaurantCategory>,
  restaurantName: string,
};

const DiningMenuMobile = (props: Props) => {
  const { restaurantCategories } = props.data;

  const { height } = useViewport();

  const selectedOutletData = restaurantCategories[0]
    ? restaurantCategories[0]
    : [];

  const [selectedCategoryData, setSelectedCategory] = useState(
    selectedOutletData[0]
  );

  const [menuItemsData, setMenuItemsData] = useState(
    selectedOutletData && selectedOutletData.length > 0
      ? selectedOutletData[0].menu
      : ''
  );

  const onSelectItem = (id, foodCategory, idx) => {
    const category = find(selectedOutletData, { id: id });
    setSelectedCategory(category);
    setMenuItemsData(foodCategory.menu);
  };

  const renderContent = () => {
    return selectedOutletData.length > 0 ? (
      menuItemsData &&
        menuItemsData.map((item, idx) => (
          <DiningMenuCard key={idx} data={item} />
        ))
    ) : (
      <h3>No Food Item At This Moment</h3>
    );
  };

  return (
    <div className={'dining-mobile-container'} style={{ height }}>
      <h1 className={'dining-menu-overlay-heading'}>Our Menu</h1>
      <div style={{ height: 'auto', marginTop: '10%' }}>
        <TextCarouselMobile
          outletFoodCategory={
            selectedOutletData.length > 0 ? selectedOutletData : []
          }
          selectedItem={onSelectItem}
          selectedId={selectedCategoryData && selectedCategoryData.id}
        />
      </div>
      <div className={'dining-menu-mobile-content normal-scroll'}>
        {renderContent()}
      </div>
    </div>
  );
};

export default DiningMenuMobile;
